"use client"

import Link from "next/link"
import { useTranslations } from "next-intl"
import { Paper, Text, Button, TbArrowLeft, TbLeaf, TbCoin } from "@forestsync/ui"
import { USER_ROLES } from "@forestsync/db"
import type { FC } from "react"

interface NotYetListedViewProps {
  role: number
}

export const NotYetListedView: FC<NotYetListedViewProps> = ({ role }) => {
  const t = useTranslations()
  const isPD =
    role === USER_ROLES.PROJECT_DEVELOPER || role === USER_ROLES.BOTH
  const namespace = isPD ? "developer" : "beneficiary"

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
      <Paper withBorder p="xl" radius="md" className="max-w-lg w-full text-center">
        <div className="flex justify-center mb-4">
          {isPD ? (
            <TbLeaf size={48} className="text-green-600 dark:text-green-400" />
          ) : (
            <TbCoin size={48} className="text-amber-600 dark:text-amber-400" />
          )}
        </div>
        <Text size="xl" fw={700} mb="sm">
          {t(`${namespace}.notYetListed.title`)}
        </Text>
        <Text size="sm" c="dimmed" mb="lg">
          {t(`${namespace}.notYetListed.description`)}
        </Text>
        <Button
          component={Link}
          href="/glassroom"
          variant="light"
          leftSection={<TbArrowLeft size={16} />}
        >
          {t(`${namespace}.notYetListed.backToGlassroom`)}
        </Button>
      </Paper>
    </div>
  )
}
